<template>
    <div class="foreignTrade">
        <banner :themeColor="'#fff'"></banner>
        <div class="container">
            <div class="midBox">
                <div class="boxTit"> 携手货拉拉，打造省心物流服务</div>
                <div class="columnBox">
                    <div class="tabContent">
                        <div class="tabItem">
                            <div class="imgBgBox imgBgBox1">
                              <div class="titBox">
                                  <div  class="tit">商通中心与货拉拉战略合作，为企业提供一站式数字化物流解决方案</div>
                                  <div class="infoT">依托货拉拉全国物流资源网络与全国冷链物流能力，依托智能调度系统和全程可视化管控，精准解决发货繁琐、比价困难、追踪不便等痛点。通过智能报价、电子化单证和标准化服务，覆盖全国主要城市及冷链需求，助力企业优化供应链效率，实现降本增效的数字化升级，为企业发展提供可靠物流保障。</div>
                              </div>
                              <div class="titImgBox">

                                   <el-image style="width: 100%;height: 100%;"  :src="require('../../assets/images/notaryServicers/hll.png')"  fit="contain" />
                              </div>
                                <!-- <div class="tit">商通中心携手货拉拉，共同为企业客户打造专业的一站式数字化物流解决方案</div>
                                <div class="infoT">                                 
                                        依托货拉拉全国优质运力资源与智能调度系统，致力解决企业在发货流程中面临的环节繁琐、比价困难、货物追踪不便等核心痛点。依托智能报价体系、全程可视化管理和电子化单证服务，为企业提供覆盖全国主要城市的标准化货运服务，有效帮助企业优化物流成本，提升运营效率，实现供应链管理的数字化升级，让物流配送成为企业发展的可靠助力。
                                </div> -->
                            </div>
                            <div class="rowBox rowBox1">
                                <div class="boxItem">
                                    <img src="../../assets/images/logisticsServices/tabIcon_04.png" alt="">
                                    <div class="tit">全国智能调度</div>
                                    <div class="infoT">
                                        直连货拉拉全国运力池，根据订单需求智能分配合适车型与线路
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/logisticsServices/tabIcon_05.png" alt="">
                                    <div class="tit">全程可视化追踪</div>
                                    <div class="infoT">
                                        运输过程中实时更新货物位置，随时掌握物流动态
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/logisticsServices/tabIcon_06.png" alt="">
                                    <div class="tit">企业专属运力池</div>
                                    <div class="infoT">
                                        整合认证合规车辆与司机，保障运力稳定与服务品质
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/logisticsServices/tabIcon_07.png" alt="">
                                    <div class="tit">便捷系统服务</div>
                                    <div class="infoT">
                                        提供统一便捷的下单与管理平台，高效处理企业物流需求
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btmBox" id="btmBox">
                <div class="boxTit">四大步骤，极速送达</div>
                <div class="smallTit">平台致力于简化从发货到签收的每一个环节。无论是交易履约还是日常运输，您均可一键发起专业物流需求，省却繁琐沟通。系统将智能匹配运力并提供全流程可视化追踪，为您带来便捷、透明、省心的高品质物流体验。</div>
                <div class="flowBox">
                    <div class="flowItem">
                        <div class="flowTit">01</div>
                        <div class="flowInfo">发布需求</div>
                         <div class="flowInfo1">填写信息，一键发布需求</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">02</div>
                        <div class="flowInfo">智能匹配</div>
                         <div class="flowInfo1">直连货拉拉海量运力，智能秒派好司机</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">03</div>
                        <div class="flowInfo">全程追踪</div>
                         <div class="flowInfo1">全程可视化追踪，实时掌握在途动态</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">04</div>
                        <div class="flowInfo">签收完成</div>
                           <div class="flowInfo1">货物安全送达，流程自动完结</div>
                    </div>
                </div>
            </div>
            <!-- 地图 -->
             <div class="mapBox">
                   <div class="boxTit"> 实时追踪，全程掌握</div>
                   <div class="smallTit"> 通过智能物流系统实时同步运输轨迹数据，用户可实时查看物流进度，掌握货物实时位置、运输状态及预估到达时间。全流程可视化监控实现运输过程的透明化管理，提升供应链协同效率。</div>
                   <div class="map_main">
                    <div id="allMap" ></div>
                     <div class="allMap_left_box">
                           <div class="allMap_box_tit">
                                <img style="width: 62px;height: 62px;border-radius: 50%;" src="../../assets/images/logisticsServices/sjlog.png" alt="">
                                <div class="allMap_box_tit_name">张师傅</div>
                           </div>
                           <div class="allMap_box_info">
                               <div class="w50">
                                    <div class="disflex">
                                        <div class="bgtit"></div>
                                        <div class="w50tit">车辆信息</div>
                                    </div>
                                    <div class="box_cph">鲁G·12345	中型货车</div>
                               </div>
                               <div class="w50">
                                   <div class="disflex">
                                        <div class="bgtit1"></div>
                                        <div class="w50tit">运输距离</div>
                                    </div>
                                    <div class="box_gls">约1500公里</div>
                               </div>
                           </div>
                           <!-- 订单状态 -->
                            <div class="allMap_order_status">
                              <div style="margin-bottom: 25px;font-weight: 600;font-size: 14px;color: #595959;">订单状态</div>
                              <el-steps direction="vertical" :active="status" :space="70">
                                 <el-step title="订单接收 "  description="今天08:00-系统已接收您的物流订单">
                                    <template #icon>
                                    <span style="color: #409EFF;"> 
                                       <img src="../../assets/images/logisticsServices/wc.png" alt="">
                                    </span>
                                    </template>
                                </el-step>
                                
                                 <el-step title="货物已装车 "  description="今天09:15-货物已经完成装车准备出发">
                                       <template #icon>
                                    <span style="color: #409EFF;"> 
                                       <img src="../../assets/images/logisticsServices/wc.png" alt="">
                                    </span>
                                    </template>
                                </el-step>
                                 <el-step title="运输中 "  description="今天09:30-货物正在运输途中">
                                       <template #icon>
                                    <span style="color: #409EFF;"> 
                                       <img :src="status >= 3 ?require('../../assets/images/logisticsServices/wc.png')  : require('../../assets/images/logisticsServices/yswc.png')" alt="">
                                    </span>
                                    </template>
                                </el-step>
                                 <el-step title="即将到达 "  description="距离目的地还有320公里">
                                           <template #icon>
                                    <span style="color: #409EFF;"> 
                                       <img  :src="status >=  4 ?require('../../assets/images/logisticsServices/wc.png')  : require('../../assets/images/logisticsServices/wz.png')" alt="">
                                    </span>
                                    </template>
                                </el-step>   
                                 <el-step title=" 配送完成"  description="预计今天16:30送达">
                                         <template #icon>
                                    <span style="color: #409EFF;"> 
                                       <img  :src="status >=  5 ?require('../../assets/images/logisticsServices/wc.png')  : require('../../assets/images/logisticsServices/ps.png')" alt="">
                                    </span>
                                    </template>
                                </el-step>                                                             
                                </el-steps>
                            </div>
                     </div>
                   </div>
             </div>
        </div>
    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, computed ,toRefs,onMounted,nextTick,watch,onBeforeUnmount} from "vue";
import { useRouter, useRoute } from "vue-router";
import MapObject from "@/components/map/js/map";
import banner from '@/components/banner.vue'
export default {
    name: "foreignTrade",
    props:{
        themeColor: {
            type: String,
            default: 'blue'
        },
    },
    components: {
        banner,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            tabIndex: 0,
        });
        
        let falg =ref(false)
        //页面跳转
        const goPage = (url) => {
            if (url) {
                window.open(url);
            }
        };
        //滚动到指定div
        const scrollToDiv = (id) => {
            let el = document.getElementById(id)
            let position = el.getBoundingClientRect().top + window.pageYOffset - 260;
            window.scrollTo({
                top: position,
                left: 0,
                behavior: 'smooth'
            });
        }
        //获取申请类型
        const applyTypeList = ref([]);
        const getApplyType = ()=>{
            // if(!mapContainer.value){
                    initMap()
            // }
          
            proxy.$request({
                url: 'TIANDITUAPI_GETDRIVEROUTE',
                method: "post",
                data:{
                    orig:"119.10,36.70", //起点
                    dest:"112.01,27.75",  //终点
                    mid:"113.70,34.00;117.32,31.89;115.66,27.82", //途经点
                    key:"36dabebf49360cf1d41b5f910a38e3c8" //天地图开发者密钥
                }
            }).then((res) => {
                 console.log(res)
            
                        const text= res.data.result;
                        const parser = new DOMParser();
                        let  initRouteList=[]
                        const xmlDoc = parser.parseFromString(text, "text/xml");
                        console.log(xmlDoc,'xmlDoc')
                        const routeString = xmlDoc.getElementsByTagName("routelatlon")[0].textContent;
                        const coordinates = routeString.split(";").map(coord => {
                        const [lon, lat] = coord.split(",").map(Number);
                        if(lon&&lat){
                            initRouteList.push([lon,lat])
                        }
        });
         
                mapObject.value.addTextLabel( initRouteList[0],initRouteList[initRouteList.length-1]);
                    let arrDate=[{
                        longitude:initRouteList[0][0],
                        latitude:initRouteList[0][1],
                        id:1,
                        type:'yuan'
                    },{
                        longitude:initRouteList[initRouteList.length-1][0],
                        latitude:initRouteList[initRouteList.length-1][1],
                        id:2,
                        type:'yuan'
                    }
                    ]
                mapObject.value.addPointIcons('wjwDraw',arrDate );
                mapObject.value.addRouteLine('initRoute',initRouteList);
                mapObject.value.addMovingCar('addMovingCar',initRouteList)
                        // }
                    }).catch((err) => {
                        console.log(err);
                    })
                }
            
                 const mapCenter = ref([116,30])
           const mapLevel = ref(5);
          const mapTypeName = ref('TSM');
          const mapObject = ref(null);
            const mapConfig = ref({
            // 地图属性配置
            mouseMove: false, // 开始鼠标移动事件
            mapMoved: false, // 地图移动完成事件
            mouseDraw: true, // 鼠标绘制
            scale:false
        })
               const initMap = ()=> {
            // 初始化地图引擎。(DOM ID，初始中心点坐标数组, 初始层级, 初始底图, 其他配置对象)
            mapObject.value = new MapObject(
                "allMap",
                mapCenter.value,
                mapLevel.value,
                mapTypeName.value,
                {
                    scale: false, // 开启比例尺
                    ...mapConfig.value,
                }
            );
        
        }
                onMounted(async () => {
                    falg.value=true
                    await nextTick();
                    getApplyType()
                    
                    });
                let status=ref(2)
        const dsqTime=()=>{
             setInterval(() => {
          // 从起点重新出发
                if(status.value==5){
                    status.value=2
                }else{
                    status.value++
                }
                }, 5000); 
                console.log(status.value)
              }
         // 在组件卸载时销毁地图
        onBeforeUnmount(() => {
         if (mapObject.value) {
            console.log('销毁地图', mapObject.value)
            mapObject.value.clear();
            mapObject.value = null;
        }
         falg.value=false
        });
        dsqTime()
        return {
            goPage,
            scrollToDiv,
            ...toRefs(state),
            applyTypeList,
            status,
            falg

        }
    },
}
</script>
<style lang="less" scoped>
.foreignTrade{
    width: 100%;
    height: 100%;
    background: #F7F7F7 ;
    box-sizing: border-box;
    padding-bottom: 50px;
    div{
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }
    img{
        width: 100%;
        height: 100%;
    }
    .boxTit{
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }
    .container{
        width: 1200px;
        margin: 0 auto;
        .midBox{
            .boxTit{
                padding: 50px 0 60px;
            }
            .columnBox{
                .topRow{
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #D8D8D8;
                    margin-bottom: 40px;
                    .leftInfo{
                        flex: 1;
                        padding-top: 78px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #595959;
                        line-height: 36px;
                        display: flex;
                        flex-direction: column;
                        .tit{
                            font-weight: 600;
                            font-size: 20px;
                            line-height: 36px;
                            margin-bottom: 28px;
                        }
                        .tabTit{
                            margin-top: auto;
                            display: flex;
                            .titItem{
                                font-weight: 600;
                                margin-right: 40px;
                                padding-bottom: 10px;
                                cursor: pointer;
                            }
                            .active{
                                font-size: 20px;
                                border-bottom: 4px solid #191919;;
                            }
                        }
                    }
                    .imgBox{
                        width: 47%;
                        height: auto;
                        img{
                            object-fit: contain;
                        }
                    }
                }
                .tabContent{
                    .tabItem{
                        .imgBgBox{
                            // height: 194px;
                            min-height: 160px;
                            width: 100%;
                            // background: url(../../assets/images/foreignTrade/tabBgImg_01.png) right top no-repeat;
                            // background-size: auto 100%;
                            // background-position: right top;
                            // padding-left: 69px;
                            // padding-top: 66px;
                            // padding-top: 30px;
                            margin-bottom: 30px;
                            border-radius: 25px;
                             display: flex;
                            align-items: center;
                            .titBox {
                              width: 50%;
                            // flex: 1;
                                  padding: 30px 40px 30px 30px;
                                .tit{
                                font-size: 20px;
                                line-height: 36px;
                                // margin-bottom: 16px;
                                font-weight: bold;
                            }
                            .infoT{
                                font-weight: 400;
                                font-size: 16px;
                                line-height: 36px;
                                // max-width: 61%;
                             }
                            }
                            .titImgBox {
                             width: 50%;
                            //   flex: 1;
                              padding: 30px 30px 30px 0;
                              img{
                                width: 100%;
                                height: 100%;
                              }
                            }

                        }
                        .imgBgBox1{
                            // background: url(../../assets/images/foreignTrade/tabBgImg_02.png) right top no-repeat;
                            // background-size: auto 100%;
                            background: #FFFFFF;
                            border-radius: 20px;
                        }
                        .imgBgBox2{
                            background: url(../../assets/images/foreignTrade/tabBgImg_03.png) right top no-repeat;
                            background-size: auto 100%;
                        }
                        .imgBgBox3{
                            background: url(../../assets/images/foreignTrade/tabBgImg_04.png) right top no-repeat;
                            background-size: auto 100%;
                        }
                        .imgBox{
                                width: 100%;
                                margin-top: 30px;
                                padding: 32px 170px 39px 69px; 
                                background: #FFFFFF;
                                border-radius: 20px;
                            .tit{
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 30px;
                            }
                            .img{
                                height: 230px;
                                img{
                                    object-fit: contain;
                                }
                            }
                        }
                    }
                    .boxBtn{
                        width: 156px;
                        height: 46px;
                        border-radius: 23px;
                        border: 1px solid #191919;
                        text-align: center;
                        line-height: 46px;
                        font-weight: 400;
                        font-size: 14px;
                        margin: 0 auto;
                        margin-top: 40px;
                        cursor: pointer;
                    }
                    .rowBox{
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        grid-column-gap: 20px;
                        grid-auto-rows: 230px;
                        .boxItem{
                            padding: 30px;
                            background: #fff;
                            border-radius: 20px;
                            img{
                                width: 50px;
                                height: 50px;
                                margin-bottom: 30px;
                            }
                            .tit{
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 8px;
                            }
                            .infoT{
                                font-weight: 400;
                                font-size: 16px;
                            }
                        }
                    }
                    .rowBox1{
                        grid-template-columns: repeat(4, 1fr);
                        grid-auto-rows: 258px;
                        .boxItem{
                            display: flex;
                            flex-direction: column;
                            .boxBtn{
                                margin-top: auto;
                            }
                        }
                    }
                    .rowBox2{
                        grid-template-columns: 1fr 3fr;
                        grid-auto-rows: 343px;
                        .boxItem{
                            display: flex;
                            flex-direction: column;
                            .boxBtn{
                                margin-top: auto;
                            }
                        }
                        .innerRowBox{
                            display: flex;
                            justify-content: space-between;
                            column-gap: 50px;
                        }
                    }
                }
            }
        }
        .mapBox{
            width: 100%;
            
             .boxTit{
                padding: 55px 0 16px;
                font-weight: 600;
                font-size: 36px;
                color: #191919;
            }
           .smallTit{
               font-weight: 400;
                font-size: 18px;
                color: #595959;
                line-height: 36px;
               text-align: center;
            }
            .map_main {
                border-radius: 20px;
                height: 700px;
                width: 100%;
                 position: relative;
                 margin-top: 32px;
            }
            // height: 700px;
            // border-radius: 20px;
        }
        .btmBox{
           margin-top: 60px;
           background: url(../../assets/images/notaryServicers/wlbg.png) no-repeat;
           background-size: 100% 100%;
           padding-bottom: 30px;
           border-radius: 20px;
          //  height: 20%;
            .boxTit{
                padding: 55px 0 16px;
                font-size: 36px;
                color: #FFFFFF;
            }
            .smallTit{
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 36px;
                margin-bottom: 30px;
                text-align: center;
                padding: 0 5%;
            }
            .flowBox{
              
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 146px;
                // margin-bottom: 145px;
                // background: #FFFFFF;
                border-radius: 20px;
                padding: 0 8%;
                margin-bottom: 30px;
                .flowItem{
                    display: flex;
                    flex-direction: column;
                    .flowTit{
                        font-size: 20px;
                        font-weight: bold;
                        background-image:linear-gradient( 90deg, #77ADFF 0%, #2280FF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        margin-bottom: 20px;
                    }
                    .flowInfo {
                      font-weight: 600;
                      font-size: 18px;
                      color: #FFFFFF;
                    }
                    .flowInfo1 {
                      font-size: 16px;
                      color: #FFFFFF;
                      line-height: 45px;
                      // padding-bottom: 146px;
                    }
                }
                .flowIcon{
                    width: 28px;
                    height: 36px;
                }
            }
        }
    }
}
@media (min-width: 1680px) {
    .foreignTrade{
        .container{
            width: 1600px;
            .midBox{
                .columnBox{
                    .topRow{
                        .leftInfo{
                            margin-right: 140px;
                        }
                        .imgBox{
                            width: 48%;
                            height: auto;
                        }
                    }
                    .tabContent{
                        .tabItem{
                            .imgBox{
                                .img{
                                    height: 310px;
                                    img{
                                        object-fit: contain;
                                    }
                                }
                            }
                        }
                        .rowBox{
                            grid-auto-rows: 210px;
                        }
                        .rowBox1{
                            grid-auto-rows: 241px;
                        }
                        .rowBox2{
                            grid-auto-rows: 333px;
                        }
                    }
                }
            }
        }
    }
}
#allMap{
    width: 100%;
    height: 100%;
    border-radius: 20px;
   
}
.allMap_left_box {
    width: 390px;
    height: 640px;
    position: absolute;
    top: 30px;
    left: 30px;
    background: #FFFFFF;
    border-radius: 20px;
    padding: 20px;
    .allMap_box_tit {
        // margin-top: 19px;
        display: flex;
        align-items: center;
        .allMap_box_tit_name{
            font-weight: 600;
            font-size: 18px;
            color: #191919;
            margin-left: 16px;
        }

    }
    .allMap_order_status {
        margin-top: 15px;
        width: 100%;
        height: 445px;
        background: #F5F9FF;
        border-radius: 10px;
        padding:20px 0 0 17px;
    }
    .allMap_box_info {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        .w50 {
        width: 49%;
        .box_cph {
            margin-top: 12px;
            background: #F5F9FF;
            border-radius: 4px;
            border: 1px solid #DDE7F6;
            font-weight: 600;
            font-size: 14px;
            color: #1663FF;
            height: 32px;
            display: flex;
            align-items: center;
            padding-left: 11px;
        }
       .box_gls {
         margin-top: 12px;
            background: #FEF2EA;
            border-radius: 4px;
            border: 1px solid #FCDAC3;
            font-weight: 600;
            font-size: 14px;
            color: #FB9049;
            height: 32px;
           display: flex;
            align-items: center;
             padding-left: 11px;
        }
        .disflex {
         display: flex;
         align-items: center;
        .bgtit {
           width: 3px;
           height: 14px;
           background: #1663FF;
           margin-right: 8px;

        }
        .bgtit1 {
             width: 3px;
           height: 14px;
           background: #FB9049;
           margin-right: 8px;
        }
        .w50tit {
            font-weight: 600;
            font-size: 14px;
            color: #595959;
        }
        }
       
    }
  }
}
:deep(.ol-zoom){
    display: none;
}
:deep(.el-step__description.is-finish){
  color: #636D7C;
}
:deep(.el-step__title.is-finish){
    color: #191919;
}
:deep(.el-step__head.is-finish){
    color: #CED3DB;
}

</style>